var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button",style:(`width:${_vm.width/100}rem;height:${_vm.height/100}rem;line-height:${_vm.height/100}rem;font-size:${_vm.fontSize/100}rem`),on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }